import Button from './Button'
import styled from 'styled-components'

export const RoundButton = styled(Button)`
  border-radius: 54px;
  padding: 15px;
`
